import { PureComponent } from "react"
import { string } from "prop-types"
import enhanceWithClickOutside from "react-click-outside"

import FormErrorMessage from "../form-error-message/form-error-message"
import CheckBox from "../check-box/check-box"
import Heading from "../heading/heading"
import Tag from "../tag/tag"

import "./multi-select.scss"

class MultiSelect extends PureComponent {
  constructor() {
    super()
    this.state = {
      editing: false,
    }
  }
  toggleSelection = (id) => {
    if (
      this.props.selectedOptions.length + 1 <= this.props.selectionMax ||
      this.props.selectedOptions.indexOf(id) > -1
    ) {
      this.props.toggleSelection({
        forLabel: this.props.forLabel,
        id,
      })
    }
  }
  handleClickOutside = (e) => {
    this.setState({
      editing: false,
    })
  }
  toggleEditing = () => {
    this.setState({
      editing: !this.state.editing,
    })
  }
  render() {
    const {
      options,
      label,
      selectedOptions,
      component,
      isValid,
      selectionMax,
      headingElement,
      validationErrorMsg,
      hideInitEdit,
      isEditable,
      isDisabled,
    } = this.props

    const { editing } = this.state

    return (
      <div className="multi-select">
        <FormErrorMessage
          isValid={isValid}
          validationErrorMsg={validationErrorMsg}
        />
        <div className="multi-select__inner">
          {!hideInitEdit || editing ? (
            <>
              <div className="multi-select__label">
                <Heading copy={label} element={headingElement} />
                <br />
                {/* {selectionMax < 999 && <div className="multi-select__choose">(choose up to {selectionMax})</div>} */}
              </div>
              <ul>
                {options.map((option) => {
                  const isSelected =
                    selectedOptions.filter((item) => item === option.itemId)
                      .length > 0
                  return (
                    <CheckBox
                      key={option.itemId}
                      {...option}
                      multiSelect
                      onClick={this.toggleSelection}
                      isSelected={isSelected}
                      component={component}
                      isDisabled={isDisabled}
                      isValid={true}
                    />
                  )
                })}
              </ul>
            </>
          ) : (
            <div className="multi-select__static">
              {options.map((option) => {
                if (
                  selectedOptions.filter(
                    (selectedOpt) => selectedOpt === option.itemId
                  ).length > 0
                ) {
                  return <Tag key={option.itemId} label={option.label} />
                }
              })}
              {isEditable && (
                <div className="text-area__static__edit">
                  <button onClick={this.toggleEditing}>Edit</button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

MultiSelect.propTypes = {
  headingElement: string,
}

MultiSelect.defaultProps = {
  headingElement: "h3",
}

export default enhanceWithClickOutside(MultiSelect)
